import { useTranslation } from 'react-i18next';
import { formatDateTime } from '@/lib/utils/date';
import type { MaintenanceSection } from '../types/maintenance.types';

function toDate(iso: string | null): Date | null {
  if (!iso) return null;
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? null : date;
}

/** "Perioada estimată: dd.mm.yyyy hh:mm – dd.mm.yyyy hh:mm" (nothing when unknown). */
export function MaintenancePeriod({ section, className }: { section: MaintenanceSection; className?: string }) {
  const { t } = useTranslation();
  const start = toDate(section.starts_at);
  const end = toDate(section.ends_at);
  if (!start || !end) return null;

  return (
    <p className={className}>
      {t('maintenance.period', { start: formatDateTime(start), end: formatDateTime(end) })}
    </p>
  );
}

/** Wrench-in-circle glyph shared by the maintenance views. */
export function MaintenanceIcon({ className = 'h-7 w-7' }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className={className} aria-hidden>
      <path
        d="M14.7 6.3a4 4 0 0 0-5.2 5.2L3 18v3h3l6.5-6.5a4 4 0 0 0 5.2-5.2l-2.6 2.6-2.1-.5-.5-2.1z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
